import React, { useEffect, useState } from "react";
import AddBranch from "../../../AddBranch/AddBranch";
import BranchSelect from "../../../../Inputs/BranchSelect/BranchSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  createBranch,
  getAllBranches,
} from "../../../../../redux/branchSlice/branchSlice";
import notify from "../../../../../hooks/useNotifaction";
import { useNavigate } from "react-router-dom";

export default function BranchCarousel({
  selectedBranch,
  setSelectedBranch,
  selectedCompany,
  isSingleBranchCompany,
  setIsSingleBranchCompany,
}) {
  const [newBranch, setNewBranch] = useState(false);
  const handleNewBranch = () => setNewBranch((prev) => !prev);
  const dispatch = useDispatch();
  const { status, error } = useSelector((state) => state.branch);

  return (
    <>
      {/* Branch Selection */}
      <div className="carousel-item">
        <div className="mt-5 companySection">
          <div className="row align-items-center mx-5 pt-5">
            <div className="col-md-6">
              <BranchSelect
                selectedCompany={selectedCompany}
                selectedBranch={selectedBranch}
                setSelectedBranch={setSelectedBranch}
              />
            </div>
            <div className="col-md-6 text-md-end text-center">
              <button
                className={`btn ${newBranch ? "btn-danger" : "btn-primary"}`}
                onClick={handleNewBranch}
              >
                {newBranch ? "الغاء" : "اضافة فرع جديدة"}
              </button>
            </div>
          </div>

          {newBranch && (
            <div className="mx-5">
              <AddBranch
                handleNewBranch={handleNewBranch}
                selectedCompany={selectedCompany}
              />
            </div>
          )}

          <div className="mx-5 my-3">
            <h4>{selectedBranch?.label || ""}</h4>
          </div>

          {/* Checkbox للشركة بفرع واحد */}
          <div className="mx-5 my-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="singleBranchCheckbox"
                checked={isSingleBranchCompany}
                onChange={(e) => setIsSingleBranchCompany(e.target.checked)}
              />
              <label
                className="form-check-label"
                htmlFor="singleBranchCheckbox"
              >
                شركة بفرع واحد
              </label>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between mx-5 my-3">
          <button
            className="btn"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span>السابق</span>
          </button>

          <button
            className={`btn btn-primary ${!selectedBranch?.value ? "d-none" : ""}`}
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            التالي
          </button>
        </div>
      </div>
    </>
  );
}
